<template>
  <div id="login-bg" class="">

    <div class="text-center pt-16">
      <img class="w-2/4 mx-auto" src="../assets/img/logo.png">
      <h1 class=" text-white text-xl font-bold mt-6">مدیریت تبرک</h1>
      <h5 class=" text-gray-300 text-sm mt-2">داشبورد مدیریتی</h5>
    </div>

    <div class="fixed bottom-0 bg-gray-300 p-8 rounded-t-xl">
      <h1 class="text-gray-700 text-center font-bold">ورود به حساب کاربری</h1>
      <h6 class="text-white rounded-xl py-2 mt-2 text-xs text-center bg-red-500" v-if="loginError">نام کاربری یا رمزعبور
        اشتباه است</h6>

      <form action="" @submit.prevent="login">
        <VInput type="tel" class="w-full mt-4" placeholder="نام کاربری" v-model="user.UserName" required/>
        <VInput type="password" class="w-full mt-4" placeholder="رمز عبور" v-model="user.Password" required/>

        <VButton class="w-full mt-4 shadow-lg" type="submit">ورود</VButton>

      </form>
    </div>

  </div>
</template>

<script>
import VButton from "@/components/General/VButton";
import VInput from "@/components/General/VInput";

export default {
  name: "LoginPage",
  components: {VInput, VButton},
  data() {
    return {
      user: {
        UserName: '',
        Password: '',
      },
      loginError: false
    }
  },
  methods: {
    login() {
      this.$store.dispatch('login', this.user)
          .then(() => {
            this.$router.push('/')
            this.loginError = false
          }).catch(() => {
        console.log("REJECTED")
        this.loginError = true
      })
    }
  }
}
</script>

<style scoped>
#login-bg {
  content: '';
  background-image: url("../assets/img/bg_login.png");
  @apply h-screen w-screen bg-no-repeat bg-cover
}

/*#login-card {*/
/*  !*background: rgba( 255, 255, 255, 0.25 );*!*/
/*  box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );*/
/*  backdrop-filter: blur( 5px );*/
/*  !*border: 1px solid rgba( 255, 255, 255, 0.18 );*!*/
/*}*/
</style>